export enum FleetState {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
